<template>
    <div class="nav-cont" fixed dense>
        <div class="nav-spacer">
           <router-link to="/" @click.native="reloadPage">
               <img
                    class="logo-icon"
                    src="../assets/logo/logo-graphic.png"
                    srcset="../assets/logo/logo-graphic@2x.png,
                            ../assets/logo/logo-graphic@3x.png"
                    alt="logo"
                />
           </router-link>
            <div class="right-nav">
                <a target="_blank" href="https://twitter.com/inheritthemusic">
                    <img
                        src="../assets/image/twitter.png"
                        srcset="../assets/image/twitter@2x.png 2x,
                                ../assets/image/twitter@3x.png 3x"
                        id="twitter"
                        class="social-media-icon"
                        alt="twitter"
                    />
                </a>
              <a target="_blank" href="https://facebook.com/InheritTheMusic">
                    <img
                        src="../assets/image/fb.png"
                        srcset="../assets/image/fb@2x.png 2x,
                                ../assets/image/fb@3x.png 3x"
                        id="fb"
                        class="social-media-icon"
                        alt="facebook"
                    />
                </a>
                <a target="_blank" href="https://www.instagram.com/inheritthemusic/">
                    <img
                        src="../assets/image/insta.png"
                        srcset="../assets/image/insta@2x.png 2x,
                                ../assets/image/insta@3x.png 3x"
                        id="insta"
                        class="social-media-icon"
                        alt="insta"
                    />
                </a>
                <TopMenu :reload-page="reloadPage" />
            </div>
        </div>
    </div>
</template>
<script>
    import TopMenu from '@/components/TopMenu';
    export default {
        name: 'NavBar',
        components: { TopMenu },
        props: {
            reloadPage: {
                type: Function
            }
        },
        data() {
            return {
                menuOpen: false,
                offsetX: true,
                overlayOpen: false,
                menuWidth: 214
            }
        },
    }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
    .nav-cont {
        display: flex;
        position: fixed;
        justify-content: center;
        align-items: center;
        background-color: black;
        height: 53px;
        width: 100%;
        padding: 0 50px;
        z-index: 100;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    .nav-spacer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%
    }

    .right-nav {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 15%;
    }

    .logo-icon {
        width: 43px;
        height: 27px;
        cursor: pointer;
    }

    #twitter {
        width: 17px;
        height: 14px;
    }

    #insta {
        width: 18px;
        height: 16px;
    }

    a {
        line-height: 0;
    }

    @media #{map-get($display-breakpoints, 'md-and-down')} {
      .right-nav {
        width: 25%
      }
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
        .right-nav {
            width: 40%;
        }

        .nav-cont {
          padding: 0 30px;
        }

        .list-item-title {
          font-size: 15px;
          margin-right: 100px;
        }
    }
</style>